import React from 'react'
import ProgressBar from '@ramonak/react-progress-bar'
import { Box, useTheme } from '@mui/material'
import * as styles from './styles'

interface AnimatedStepsProps {
  currentStep: number
  totalSteps: number
}

const AnimatedSteps: React.FC<AnimatedStepsProps> = ({ currentStep, totalSteps }) => {
  const theme = useTheme()
  return (
    <Box sx={styles.stepsContainer}>
      <ProgressBar
        completed={currentStep * (100 / totalSteps)}
        height="4px"
        borderRadius="0"
        transitionDuration="0.5s"
        bgColor={theme.palette.primary[400]}
        isLabelVisible={false}
      />
    </Box>
  )
}

export default AnimatedSteps
